import type { Entity } from '@backstage/catalog-model';

/**
 * Onglets d'une fiche à masquer pour ce composant, séparés par des virgules.
 * Exemple : un consumer qui exécute le code du frontend n'a pas à répéter ses merge
 * requests ni ses pipelines (`merge-requests, pipelines, security`).
 */
export const HIDDEN_TABS_ANNOTATION = 'platform.io/hidden-tabs';

/**
 * Identifiants stables des onglets masquables (la vue d'ensemble ne l'est jamais).
 * Documentés dans IMPLEMENTATIONS.md : les catalogues clients s'y réfèrent.
 */
export type HideableTab =
  | 'merge-requests'
  | 'pipelines'
  | 'deployments'
  | 'kubernetes'
  | 'cronjobs'
  | 'env'
  | 'monitoring'
  | 'security';

/** L'onglet `tab` figure dans `platform.io/hidden-tabs` (casse et espaces ignorés). */
export function isTabHidden(entity: Entity, tab: HideableTab): boolean {
  const raw = entity.metadata.annotations?.[HIDDEN_TABS_ANNOTATION];
  if (!raw) return false;
  return raw
    .split(',')
    .map(t => t.trim().toLowerCase())
    .includes(tab);
}

/** Filtre d'onglet : le filtre existant, sauf si le composant masque l'onglet. */
export function tabVisible(
  tab: HideableTab,
  filter: (entity: Entity) => boolean,
): (entity: Entity) => boolean {
  return entity => filter(entity) && !isTabHidden(entity, tab);
}
